module.exports = __webpack_public_path__ + "static/media/photography-2-2.d6a9309d.jpg";